<template>
  <div class="h-10/100">
    <div class="flex">
      <div class="flex-1 flex items-center justify-start">
        <div v-if="!hideBackButton">
          <hit-button
            icon-size="lg"
            suffix-icon="back"
            color="accent"
            @click="$emit('previousClick')"
          />
        </div>
      </div>
      <div class="flex-1 flex items-center justify-end">
        <div v-if="!hideNextButton">
          <hit-button
            color="accent"
            :disabled="disableClick"
            suffix-icon="forward"
            icon-size="lg"
            @click="$emit('nextClick')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {useI18n} from 'vue-i18n';
import {defineComponent} from 'vue';
import {HitButton} from '@hit/components/src';

export default defineComponent({
  name: 'TopBarNavigation',
  components: {
    HitButton,
  },
  props: {
    disableClick: {
      type: Boolean,
      default: false,
    },
    hideBackButton: {
      type: Boolean,
      default: false,
    },
    hideNextButton: {
      type: Boolean,
      default: false,
    },
    suffixIconPrevious: {
      type: String,
      default: 'back',
    },
    suffixIconNext: {
      type: String,
      default: 'forward',
    },
    colorIconPrevious: {
      type: String,
      default: 'accent',
    },
    colorIconNext: {
      type: String,
      default: 'accent',
    },
  },
  emits: ['previousClick', 'nextClick'],
  setup() {
    const {t} = useI18n();
    return {t};
  },
  data() {},
});
</script>
